import { useState } from 'react'

const EMPTY = {
  name: '', ha: '', ordem: '', uso: 'lavoura',
  cultura_inverno: '', opcao_inverno: '', opcao_milho: '',
}

export default function AreaFormModal({ area, onSave, onClose }) {
  const isEdit = !!area
  const [form, setForm] = useState(
    isEdit
      ? {
          name: area.name,
          ha: String(area.ha),
          ordem: String(area.ordem ?? 0),
          uso: area.uso ?? 'lavoura',
          cultura_inverno: area.cultura_inverno ?? '',
          opcao_inverno: area.opcao_inverno ?? '',
          opcao_milho: area.opcao_milho ?? '',
        }
      : EMPTY
  )
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')

  function set(field) {
    return (e) => setForm(f => ({ ...f, [field]: e.target.value }))
  }

  async function handleSave() {
    if (!form.name.trim()) return setError('Nome é obrigatório')
    if (!form.ha || isNaN(Number(form.ha))) return setError('Hectares inválido')
    setSaving(true)
    setError('')
    try {
      await onSave({
        name: form.name.trim(),
        ha: Number(form.ha),
        ordem: form.ordem !== '' ? Number(form.ordem) : 0,
        uso: form.uso || 'lavoura',
        cultura_inverno: form.cultura_inverno || null,
        opcao_inverno: form.opcao_inverno || null,
        opcao_milho: form.opcao_milho || null,
      })
      onClose()
    } catch (e) {
      setError(e.message)
    } finally {
      setSaving(false)
    }
  }

  return (
    <div style={overlay} onClick={onClose}>
      <div style={card} onClick={e => e.stopPropagation()}>
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 11, color: '#86efac', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase' }}>
            {isEdit ? 'Editar Área' : 'Nova Área'}
          </div>
          <div style={{ fontSize: 18, fontWeight: 800, color: '#fff', marginTop: 2 }}>
            {isEdit ? `✏️ ${area.name}` : '➕ Adicionar área'}
          </div>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px 16px' }}>
          <div style={{ gridColumn: '1 / -1' }}>
            <label style={labelStyle}>Nome da área *</label>
            <input value={form.name} onChange={set('name')} style={inputStyle} placeholder="Ex: Paris 1" autoFocus />
          </div>
          <div>
            <label style={labelStyle}>Hectares *</label>
            <input value={form.ha} onChange={set('ha')} style={inputStyle} placeholder="Ex: 10.5" type="number" step="0.01" min="0" />
          </div>
          <div>
            <label style={labelStyle}>Ordem</label>
            <input value={form.ordem} onChange={set('ordem')} style={inputStyle} placeholder="Ex: 5" type="number" min="0" />
          </div>
          <div style={{ gridColumn: '1 / -1' }}>
            <label style={labelStyle}>Tipo de uso</label>
            <select value={form.uso} onChange={set('uso')} style={inputStyle}>
              <option value="lavoura" style={{ background: '#052e16' }}>🌾 Lavoura</option>
              <option value="pastagem" style={{ background: '#052e16' }}>🐄 Pastagem</option>
              <option value="outro" style={{ background: '#052e16' }}>📍 Outro</option>
            </select>
          </div>
          <div>
            <label style={labelStyle}>Cultura Inverno</label>
            <input value={form.cultura_inverno} onChange={set('cultura_inverno')} style={inputStyle} placeholder="Ex: Trigo" />
          </div>
          <div>
            <label style={labelStyle}>Opção Inverno</label>
            <input value={form.opcao_inverno} onChange={set('opcao_inverno')} style={inputStyle} placeholder="Ex: Bagual" />
          </div>
          <div style={{ gridColumn: '1 / -1' }}>
            <label style={labelStyle}>Opção Milho</label>
            <input value={form.opcao_milho} onChange={set('opcao_milho')} style={inputStyle} placeholder="Ex: 3016" />
          </div>
        </div>

        {error && (
          <div style={{ background: '#fee2e2', color: '#7f1d1d', padding: '8px 12px', borderRadius: 8, fontSize: 13, marginTop: 12 }}>
            {error}
          </div>
        )}

        <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
          <button onClick={onClose} style={cancelBtnStyle} disabled={saving}>Cancelar</button>
          <button onClick={handleSave} style={saveBtnStyle} disabled={saving}>
            {saving ? 'Salvando...' : isEdit ? 'Salvar alterações' : 'Criar área'}
          </button>
        </div>
      </div>
    </div>
  )
}

const overlay = {
  position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
  display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
}
const card = {
  background: '#14532d', borderRadius: 16, padding: '28px 32px',
  minWidth: 380, maxWidth: 480, width: '100%',
  boxShadow: '0 8px 40px rgba(0,0,0,0.4)',
}
const labelStyle = {
  display: 'block', fontSize: 10, fontWeight: 700, color: '#86efac',
  letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: 4,
}
const inputStyle = {
  width: '100%', padding: '9px 12px', borderRadius: 8,
  border: '1.5px solid #16a34a', background: '#052e16',
  color: '#fff', fontSize: 14, boxSizing: 'border-box',
}
const cancelBtnStyle = {
  flex: 1, padding: '10px 0', borderRadius: 8, border: '1.5px solid rgba(255,255,255,0.2)',
  background: 'transparent', color: '#fff', cursor: 'pointer', fontWeight: 600, fontSize: 14,
}
const saveBtnStyle = {
  flex: 2, padding: '10px 0', borderRadius: 8, border: 'none',
  background: '#16a34a', color: '#fff', cursor: 'pointer', fontWeight: 700, fontSize: 14,
}
